import { requestHandler } from '../../api';

export const checkReverseFNC = async (dispatch: any, fncId: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/notRecognizedPayment/${fncId}/checkReverse`,
    dispatch,
  });
  if (response) return response.data;
};

export const reverseFNC = async (dispatch: any, fncId: number) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/notRecognizedPayment/${fncId}/reverse`,
    dispatch,
  });
  if (response) return response.data;
};

export const checkDeleteFNCPendingAccount = async (
  dispatch: any,
  fncId: number,
  pendingAccountId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/notRecognizedPayment/${fncId}/checkDeletePendingAccount/${pendingAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFNCPendingAccount = async (
  dispatch: any,
  fncId: number,
  pendingAccountId: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/notRecognizedPayment/${fncId}/deletePendingAccount/${pendingAccountId}`,
    dispatch,
  });
  if (response) return response.data;
};
